import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    connectionStatus: 'online', // 'online' | 'offline' | 'unknown'
    operations: {
      profile: { count: 0, error: null, status: 'idle' }, // status: 'idle' | 'loading' | 'saving' | 'syncing' | 'error'
      calendar: { count: 0, error: null, status: 'idle' },
      calendarLoad: { count: 0, error: null, status: 'idle' },
      chats: { count: 0, error: null, status: 'idle' },
      messages: { count: 0, error: null, status: 'idle' },
      upload: { count: 0, error: null, status: 'idle' },
    },
  },
  reducers: {
    setConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload;
    },
    incrementOperation: (state, action) => {
      const type = action.payload;
      if (!state.operations[type]) {
        state.operations[type] = { count: 0, error: null, status: 'idle' };
      }
      state.operations[type].count += 1;
      state.operations[type].error = null; // Clear error on new operation
      state.operations[type].status = 'syncing';
    },
    decrementOperation: (state, action) => {
      const type = action.payload;
      if (state.operations[type]) {
        state.operations[type].count = Math.max(0, state.operations[type].count - 1);
        if (state.operations[type].count === 0) {
          state.operations[type].status = 'idle';
        }
      }
    },
    setOperationError: (state, action) => {
      const { type, error } = action.payload;
      if (state.operations[type]) {
        state.operations[type].error = error;
        state.operations[type].status = 'error';
      }
    },
    clearOperationError: (state, action) => {
      const type = action.payload;
      if (state.operations[type]) {
        state.operations[type].error = null;
        if (state.operations[type].count === 0) {
          state.operations[type].status = 'idle';
        } else {
          state.operations[type].status = 'syncing';
        }
      }
    },
  },
});

export const {
  setConnectionStatus,
  incrementOperation,
  decrementOperation,
  setOperationError,
  clearOperationError,
} = loadingSlice.actions;

export default loadingSlice.reducer;
